import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import OrdersSuccessMock from './mocks/OrdersSuccessMock';
import photoOrganic from '../../assets/onboarding/organic.jpg';
import { useOnboardingOptional } from './OnboardingContext';
import styles from './FirstSaleCelebration.module.scss';

const FirstSaleCelebration: React.FC = () => {
  const onboarding = useOnboardingOptional();
  const navigate = useNavigate();

  if (!onboarding?.celebrateOpen) return null;

  const close = async () => {
    await onboarding.markCelebrated();
    navigate('/home');
  };

  return (
    <Modal show centered onHide={() => void close()} contentClassName={styles.modal}>
      <div
        className={styles.banner}
        style={{ backgroundImage: `url(${photoOrganic})` }}
      />
      <Modal.Body className={styles.body}>
        <p className={styles.eyebrow}>Listo</p>
        <h2 className={styles.title}>¡Tu primera venta está aprobada!</h2>
        <p className={styles.copy}>
          Ya tienes el flujo completo: producto, cliente y venta. Desde aquí
          puedes seguir creciendo el catálogo y el equipo.
        </p>
        <div className={styles.mockWrap}>
          <OrdersSuccessMock />
        </div>
        <Button variant="primary" className="w-100" onClick={() => void close()}>
          Ir al inicio
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default FirstSaleCelebration;
